import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../config/config";
import "../css/login.css";

function ResetPassword() {

    const { token } = useParams();

    const navigate = useNavigate();

    const [password, setPassword] = useState("");

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const res = await axios.post(
                `${API_URL}/reset-password`,
                {
                    token,
                    password
                }
            );

            alert(res.data.message);

            navigate("/login");

        }

        catch (err) {

            alert(
                err.response?.data?.message ||
                "Something went wrong."
            );

        }

    };

    return (

        <div className="login-page">

            <div className="login-card">

                <h1>Reset Password</h1>

                <p>Enter your new password.</p>

                <form
                    className="login-form"
                    onSubmit={handleSubmit}
                >

                    <input
                        type="password"
                        placeholder="New Password"
                        value={password}
                        onChange={(e)=>setPassword(e.target.value)}
                        required
                    />

                    <button type="submit">
                        Reset Password
                    </button>

                </form>

            </div>

        </div>

    );

}

export default ResetPassword;